/**
 * Drawer menu interactions: tab switching, banner carousel, newsletter popup.
 */
(function () {
  if (window.drawerMenuInitialized) return;
  window.drawerMenuInitialized = true;

  function initBannerCarousel() {
    var openNavButton = document.querySelector('.js-drawer-open-nav');
    if (!openNavButton) return;

    var flickityInitialized = false;

    openNavButton.addEventListener('click', function () {
      setTimeout(function () {
        var carousel = document.querySelector('.menu-drawer-banners');
        if (!carousel || flickityInitialized) return;

        var items = carousel.querySelectorAll('.carousel-cell');
        if (items.length < 2) return;

        new Flickity(carousel, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          groupCells: 2,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
        });

        flickityInitialized = true;
        carousel.style.opacity = '1';
      }, 1000);
    });
  }

  function initTabSwitching() {
    var navDrawer = document.querySelector('#NavDrawer');
    if (!navDrawer) return;

    var tabItems = document.querySelectorAll('.menu-drawer-tabs-item');
    var tabContents = document.querySelectorAll('.menu-drawer-tabs-content .tab-element');
    var scrollable = navDrawer.querySelector('.drawer__scrollable');
    if (!tabItems.length || !tabContents.length) return;

    function hideAllTabContent() {
      tabContents.forEach(function (content) {
        content.style.display = 'none';
      });
    }

    function showTabContent(blockValue) {
      tabContents.forEach(function (content) {
        if (content.getAttribute('data-block') === blockValue) {
          content.style.display = 'flex';
        }
      });
    }

    hideAllTabContent();

    var initialBlock = tabItems[0].getAttribute('data-block');
    showTabContent(initialBlock);
    tabItems[0].classList.add('active');

    tabItems.forEach(function (item) {
      item.addEventListener('click', function () {
        navDrawer.classList.remove('drawer--drilled');

        document.querySelectorAll('.secondary-level__item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });

        tabItems.forEach(function (tab) {
          tab.classList.remove('active');
        });

        item.classList.add('active');

        var blockValue = item.getAttribute('data-block');
        hideAllTabContent();
        showTabContent(blockValue);

        if (scrollable) {
          scrollable.scrollTop = 0;
        }
      });
    });
  }

  function initNewsletterPopup() {
    var newsletterButtons = document.querySelectorAll('.mailing-list-menu-drawer');
    var newsletterPopup = document.querySelector('.newsletter-header-popup');
    var closeNewsletterButton = document.querySelector('.close-header-newsletter');

    if (newsletterButtons.length && newsletterPopup) {
      newsletterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          newsletterPopup.classList.toggle('hide');
        });
      });
    }

    if (closeNewsletterButton && newsletterPopup) {
      closeNewsletterButton.addEventListener('click', function () {
        newsletterPopup.classList.add('hide');
      });
    }
  }

  function init() {
    initBannerCarousel();
    initTabSwitching();
    initNewsletterPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
